import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FileRequired } from 'views/document-request/types';

type UseDocumentRequestItemHooksParams = {
  fileRequired: FileRequired,
  onAddFile: ({ archiveId, file }: { archiveId: string, file: File }) => void,
  onRemoveFile: ({ archiveId, fileName }: { archiveId: string, fileName: string }) => void,
}

export const useDocumentRequestItemHooks = ({
  fileRequired,
  onAddFile,
  onRemoveFile
}: UseDocumentRequestItemHooksParams) => {
  const { t } = useTranslation();
  const { acceptedFiles, getInputProps, getRootProps } = useDropzone({
    maxSize: 31457280,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/vnd.oasis.opendocument.text': ['.odt'],
      'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
    },
    noClick: false,
    noKeyboard: true,
    onDropAccepted: (files) => {
      files.forEach((file) => onAddFile({ archiveId: fileRequired.archive_id, file }));
    },
  });

  const removeFile = ({ file }: { file: File }) => {
    const files = acceptedFiles as File[];
    files.splice(files.indexOf(file), 1);
    onRemoveFile({ archiveId: fileRequired.archive_id, fileName: file.name });
  };

  return {
    t,
    acceptedFiles,
    getInputProps,
    getRootProps,
    removeFile
  };
};
